import { render, staticRenderFns } from "./withdrawEdit.vue?vue&type=template&id=815bdbf8"
import script from "./withdrawEdit.vue?vue&type=script&lang=ts"
export * from "./withdrawEdit.vue?vue&type=script&lang=ts"
import style0 from "./withdrawEdit.vue?vue&type=style&index=0&id=815bdbf8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports